/**
 * v3Config.js
 * Base URL exclusiva para las rutas nuevas del protocolo v2/v3 vigente desde 2026-08-05
 * (routes_v3.ts / v3_controllers en api-portal-manager).
 *
 * Completamente separado de dashboardConfig.js — ese archivo ya lo usan Dashboard V2 /
 * LobbyV2 y otros endpoints existentes; no debe compartir base URL con este, para que
 * un cambio de subdominio en uno nunca afecte al otro.
 *
 * Para pasar de local → subdominio v3 real, cambia solo esta línea:
 *   portalManagerV3: "https://<subdominio-v3-real-por-definir>",
 */

const v3Config = {
  portalManagerV3: "https://backv3.portalmanager.pro", // PRODUCCION V3 (futuro)
  // portalManagerV3: "http://localhost:4820",                       // LOCAL
};

export default v3Config;
